var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWecookVert512(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1339_30827)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1339_30827",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 113,
    width: 512,
    height: 286
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M512 113H0V398.867H512V113Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1339_30827)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M136.151 183.792L114.051 116.422H77.306L54.9397 183.525L36.0347 116.422H0L35.591 229.92H70.6492L94.8796 156.595L119.465 229.92H153.902L189.049 116.422H155.056L136.151 183.792Z",
    fill: "#00894E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.608 113C223.23 113 196.071 136.286 196.071 172.815C196.071 210.944 223.851 233.341 255.093 233.341C283.85 233.341 301.867 216.898 307.281 197.256L278.348 189.08C275.152 197.968 268.052 203.922 255.537 203.922C242.046 203.922 230.419 194.768 229.798 181.969H308.702C308.968 181.259 309.412 176.015 309.412 171.215C309.412 134.686 287.756 113 252.608 113ZM230.508 159.572C231.218 151.129 238.496 140.375 253.052 140.375C269.472 140.375 275.418 150.862 275.862 159.572H230.508Z",
    fill: "#00894E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.7974 366.569C46.4192 366.569 34.3484 356.526 34.3484 338.484C34.3484 320.264 45.9755 310.22 60.265 310.22C73.667 310.22 80.5013 318.398 83.075 327.108L114.051 317.775C109.08 297.511 90.7968 278.313 59.6437 278.313C26.3604 278.313 0 303.199 0 338.484C0 373.591 27.0704 398.477 60.7974 398.477C91.063 398.477 109.791 378.834 114.761 359.015L84.2291 349.682C81.7438 358.126 74.1995 366.569 60.7974 366.569Z",
    fill: "#00894E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.892 278.313C155.165 278.313 128.804 303.199 128.804 338.306C128.804 373.413 155.253 398.477 188.892 398.477C222.796 398.477 248.979 373.413 248.979 338.306C248.979 303.199 222.796 278.313 188.892 278.313ZM188.892 366.569C175.933 366.569 163.419 357.237 163.419 338.306C163.419 319.108 175.933 310.22 188.892 310.22C202.116 310.22 214.365 319.108 214.365 338.306C214.365 357.415 202.116 366.569 188.892 366.569Z",
    fill: "#00894E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.108 278.313C289.381 278.313 263.021 303.199 263.021 338.306C263.021 373.413 289.47 398.477 323.108 398.477C357.013 398.477 383.196 373.413 383.196 338.306C383.196 303.199 357.013 278.313 323.108 278.313ZM323.108 366.569C310.15 366.569 297.636 357.237 297.636 338.306C297.636 319.108 310.15 310.22 323.108 310.22C336.333 310.22 348.581 319.108 348.581 338.306C348.581 357.415 336.333 366.569 323.108 366.569Z",
    fill: "#00894E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.915 332.797L511.024 285.069H466.202L431.856 323.197V233.342H397.24V398.478H431.856V370.658L442.949 358.571L469.577 398.478H512.001L466.915 332.797Z",
    fill: "#00894E"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1339_30827"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 285.867,
    fill: "white",
    transform: "translate(0 113)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWecookVert512);
export default __webpack_public_path__ + "static/media/wecook-vert-512.aa7cfc403dc41dc77f7cbe1cfadec6c1.svg";
export { ForwardRef as ReactComponent };